import defaultStyles from "../../../styles/defaultStyles";

export default {
  prompt: {
    composes: "$defaultStyles",
    fontWeight: "500",
    wordBreak: "break-word",
    color: "black",
    backgroundColor: "white",
    position: "relative",
    padding: "12px 14px",
    marginTop: "13px",
    marginBottom: "10px",
    whiteSpace: "pre-line",
    maxWidth: "200px",
    right: "40px",
    borderRadius: "3px",
    boxShadow: "0 2px 15px rgba(0, 0, 0, 0.2)",
    zIndex: "2147483647",
    animationName: "$slide-up ",
    animationDuration: "0.4s",
    animationTimingFunction: "ease",
    boxSizing: "content-box",
  },
  text: {
    marginBottom: "7px",
    marginLeft: "5px",
  },
  close: {
    position: "absolute",
    backgroundColor: "white !important",
    justifyContent: "center",
    top: "-10px",
    right: "-10px",
    height: "27px !important",
    width: "27px",
    borderRadius: "50%",
    border: "solid #ededed 1px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1) !important",
    "&:hover": { backgroundColor: "rgb(232, 232, 232) !important" },
  },
  promptArrow: {
    bottom: "-10px",
    right: "5%",
    border: "30px solid transparent",
    height: "0",
    width: "0",
    position: "absolute",
    pointerEvents: "none",
    borderTopColor: "white",
    borderTopWidth: "10px",
    borderLeftWidth: "10px",
    borderRightWidth: "0",
    borderBottomWidth: "0",
    filter: "drop-shadow(0 10px 10px rgba(0, 0, 0, 0.3))",
  },
  "@keyframes slide-up": {
    "0%": { opacity: "0", transform: "translateY(40px)" },
    "100%": { opacity: "1", transform: "translateY(0)" },
  },
  ...defaultStyles,
};
